import React, { useLayoutEffect, useEffect, useState } from 'react';

import isMobile from '~/utils/is-mobile';

import BG from '~/components/background';

import main_video from './images/main_video.mp4';
import main_text from './images/main_text.png';

import mid_01 from './images/mid_01.png';

import mid_video from './images/mid_video.mp4';
import mid_text from './images/mid_text.png';

import mid_02 from './images/mid_02.png';

import outter from './images/outter.png';
import inner_01 from './images/inner_01.png';
import inner_02 from './images/inner_02.png';
import complex_01 from './images/complex_01.png';
import complex_02 from './images/complex_02.png';

import footer from './images/footer.png';

import answer_btn from './images/answer_btn.png';

import { Wrap, VideoWrap, BGWrap, Overlay, Modal, Close } from './styled';

function Introduce() {
  const [isOpen, setOpen] = useState(false);
  const [modalType, setModalType] = useState('');

  useLayoutEffect(() => {
    if (isMobile.any()) return window.location.replace('/2022/12/introduce-mobile/');

    document.body.style.maxWidth = '1920px';
    setOpen(true);

    return () => {
      setOpen(false);
      document.body.style.maxWidth = '640px';
    };
  }, []);

  useEffect(() => {
    if (modalType) {
      document.body.style.overflowY = 'hidden';
    } else {
      document.body.style.overflowY = 'scroll';
    }
  }, [modalType]);

  if (!isOpen) return null;

  return (
    <Wrap>
      <VideoWrap width={1920} height={780}>
        <video autoPlay muted loop playsInline width="100%" height="100%">
          <source src={main_video} type="video/mp4" />
        </video>

        <img src={main_text} />
      </VideoWrap>

      <BGWrap width={1920} height={1203} imgUrl={mid_01}>
        <button className="outter" onClick={() => setModalType('outter')} />
        <button className="inner" onClick={() => setModalType('inner')} />
        <button className="complex" onClick={() => setModalType('complex')} />
      </BGWrap>

      <VideoWrap width={1920} height={594}>
        <video autoPlay muted loop playsInline width="100%" height="100%">
          <source src={mid_video} type="video/mp4" />
        </video>

        <img src={mid_text} />
      </VideoWrap>

      <BG width={3840} height={2462} imgUrl={mid_02} />

      <BG width={3840} height={472} imgUrl={footer} />

      <a className="answer-btn" href="https://dabangapp.com?salesAdInquiry=true">
        <img src={answer_btn} alt="문의하기 버튼" style={{ width: 80, height: 80 }} />
      </a>

      {modalType && (
        <Overlay>
          <Modal>
            <Close onClick={() => setModalType('')} />

            <div className="box">
              {modalType === 'outter' ? (
                <>
                  <h2>외부투어</h2>
                  <p>단지 뿐만 아니라 주변 입지까지, 실제 고도를 반영해 더욱 생생한 외부 투어가 가능합니다.</p>

                  <div className="img-box" style={{ marginTop: 'auto', width: '100%' }} onClick={() => window.open("http://13.209.83.132:8085/ModelHouse/a4/")}>
                    <img id="a4" src={outter} />
                  </div>
                </>
              ) : modalType === 'inner' ? (
                <>
                  <h2>내부투어</h2>
                  <p>Full 3D 방식으로 기본옵션, 유상옵션, 가구배치까지 다양한 옵션으로 체험 가능합니다.</p>

                  <div className="img-box" style={{ marginTop: 'auto', width: '100%' }}>
                    <img id="a0" src={inner_01} onClick={() => window.open("http://13.209.83.132:8085/ModelHouse/a0/")} />
                    <img id="a1" src={inner_02} onClick={() => window.open("http://13.209.83.132:8085/ModelHouse/a1/")} />
                  </div>
                </>
              ) : modalType === 'complex' ? (
                <>
                  <h2>단지투어</h2>
                  <p>조경, 입∙출입구, 커뮤니티 시설, 주차장 등 단지 안을 직접 볼 수 있습니다.</p>

                  <div className="img-box" style={{ marginTop: 'auto', width: '100%' }}>
                    <img id="a2" src={complex_01} onClick={() => window.open("http://13.209.83.132:8085/ModelHouse/a2/")} />
                    <img id="a3" src={complex_02} onClick={() => window.open("http://13.209.83.132:8085/ModelHouse/a3/")} />
                  </div>
                </>
              ) : null}
            </div>
          </Modal>
        </Overlay>
      )}
    </Wrap>
  )
}

export default Introduce;
